import { useEffect } from "react";

export const useVisualViewport = (
  open: boolean,
  dialogContentRef: React.RefObject<HTMLDivElement>,
  paperRef: React.RefObject<HTMLDivElement>
) => {
  useEffect(() => {
    if (!open) return;

    const vv = window.visualViewport;
    if (!vv) return;

    let raf = 0;
    const onVVChange = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        try {
          const viewportHeight = vv.height;
          const fullHeight = window.innerHeight;
          const keyboardHeight = Math.max(0, fullHeight - viewportHeight);

          if (dialogContentRef.current) {
            if (keyboardHeight > 0) {
              dialogContentRef.current.style.maxHeight = `calc(90vh - ${keyboardHeight}px)`;
            } else {
              dialogContentRef.current.style.maxHeight = "";
            }
          }

          if (paperRef.current) {
            if (keyboardHeight > 0) {
              paperRef.current.style.transform = `translateY(-${Math.round(
                keyboardHeight * 0.45
              )}px)`;
            } else {
              paperRef.current.style.transform = "";
            }
          }
        } catch (e) {
          // ignore
        }
      });
    };

    const dialogContent = dialogContentRef.current;
    const paper = paperRef.current;

    vv.addEventListener("resize", onVVChange);
    vv.addEventListener("scroll", onVVChange);
    onVVChange();

    return () => {
      cancelAnimationFrame(raf);
      try {
        vv.removeEventListener("resize", onVVChange);
        vv.removeEventListener("scroll", onVVChange);
      } catch (e) {
        // ignore
      }
      if (dialogContent) {
        dialogContent.style.maxHeight = "";
      }
      if (paper) {
        paper.style.transform = "";
      }
    };
  }, [open, dialogContentRef, paperRef]);
};
